import {
  ColumnHeader,
  OtherAssetType,
  OwnerModelDTO,
  OwnerOptionsDTO,
} from '../../OtherAssets.meta';

export const columnHeaders: ColumnHeader[] = [
  { text: 'Recipient' },
  { text: 'Type' },
  { text: 'Monthly Payment', align: 'right' },
  { text: 'Dist Age' },
];

export enum PensionPlanTypeEnum {
  SingleLife,
  JointSurvivor,
  LumpSum,
}

export interface PensionDTO {
  Id: string;
  Name: string;
  Recipient: string;
  PensionPlanType: PensionPlanTypeEnum | null;
  MonthlyPayment: number | null;
  DistributionAtRetirement: boolean | null;
  DistributionAge: number | null;
  IsInflationAdjusted: boolean | null;
  Inflation: number | null;
  SurvivorBenefit: number | null;
  LumpSumAmount: number;
  IsIntegrated: boolean | null;
  SyncSourceLabel: string | null;
  SyncAssetValueEnabled: boolean | null;
  OtherAssetType: OtherAssetType;
  IsLiquid: boolean;
  IncludeInGrossEstate: boolean;
  CustomBucketIndex: number | null;
  OrionManagementStyleId: number | null;
  OwnerModel: OwnerModelDTO[];
}

export interface PensionsOptionsDTO {
  AllowUnequalOwnership: boolean;
  // Its not a bug, some are PascalCase and some are camelCase

  // PascalCase properties
  IsLiquid: boolean;
  DefaultAssetBucketIndex: number | null;

  // camelCase properties
  recepientOptions: OwnerOptionsDTO;
  distributionAgeOptions: number[];
  planTypeOptions: {
    label: string;
    value: PensionPlanTypeEnum;
  }[];
  distributionAgeOptionsPrincipal: number[];
  distributionAgeOptionsSpouse: number[];
}
